import React, { useState, useEffect, useRef } from 'react';
import mainPicture from './rohans-dev-main-picture.png';
import cartoonBannerGif from './Cartoon_Banner_Animation_Final.gif';
import repatArmeniaImg from './rohan-singh-repat-armenia.webp';
import successStoryImg from './rohan-singh-success-story.jpg';

// --- CONFIGURATION DATA ---
const PORTFOLIO_DATA = {
  name: "rohan singh",
  title: "senior cloud platform engineer",
  focusAreas: "cloud | infrastructure | devops | motorcyclist",
  company: "sada, an insight company",
  locationDetails: "born in india | living in armenia | raised by the 90's and 20's | living in the ☁️ since sept 2017 | google developer expert" ,
  about: "a seasoned senior cloud platform engineer with a deep focus on designing, deploying, and optimizing robust, scalable, and cost-efficient infrastructure on google cloud platform (gcp). passionate about devops practices, automation, and driving innovation through technology.",
  email: "rohankalhans@gmail.com",
  linkedin: "https://www.linkedin.com/in/rohankalhans/",
  medium: "https://rohankalhans.medium.com/",
  wakatime: "https://wakatime.com/@rohankalhans",
};

const CAREER_HISTORY = [
  { 
    company: "sada, an insight company", 
    duration: "may 2022 - present",
    companyDescription: "a google cloud premier partner with expertise in consulting, solutioning and designing modern infrastructures w/ the capabilities of migration, empowering them to go beyond",
    positions: [
      { 
        title: "senior cloud platform engineer", 
        duration: "apr, 2023 - present",
        description: [
          "spearheaded migration of 15+ legacy on-prem applications to gcp with solution architects, implementing gitops using gitlab, helm, kustomize, and argocd for gke deployments",
          "provided on-call sre support for client's gcp infrastructure, automated workflows via azure devops pipelines, and developed python/bash automation scripts",
          "troubleshot gcp resources and third-party tools, configured monitoring and alerting using prometheus, grafana, new relic, splunk, and native gcp tools"
        ]
      },
      { 
        title: "senior cloud infrastructure engineer", 
        duration: "feb, 2023 - mar, 2025",
        description: [
          "led end-to-end cloud infrastructure and devops implementation for internal ai product, including automated cicd pipelines",
          "assisted security company in designing ansible roles, ensuring infrastructure compliance, and automating with spacelift",
          "consulted logistics company on multi-cloud, hybrid cloud, iaas, gke enterprise, kubernetes, and networking architecture",
          "set up centralized logging using splunk as external data source, implemented gitlab ci and iac for infrastructure and app deployment",
          "migrated standard and specialty services department from azure to gcp via containerization using cloud run, cloud build, and cloud deploy",
          "converted 30+ chef scripts to puppet for multinational transportation company, performed testing, troubleshooting, and production deployment",
          "led large-scale aws to gcp migration for major adtech company using chef, vault, terraform, terragrunt, argocd, and bash. collaborated with dbas to migrate petabytes of sql data using gcp dms. configured prometheus and grafana monitoring, reducing infrastructure costs while improving scalability and availability"
        ]
      },
      { 
        title: "cloud infrastructure engineer", 
        duration: "may 2022 - jan 2023",
        description: [
          "designed and implemented microservices architecture, devops methodology, cicd, s3 to gcs migration, and automation for security organization, ensuring timely project delivery with comprehensive documentation",
          "developed and executed gcp media cdn (multi-cdn video delivery strategy) for streaming client using terraform, optimizing quality of service and rolling 50 pb of traffic in phased approach",
          "implemented gcp foundation for large private us university and cpam organization, setting up iam and adopting cloud-first best practices",
          "authored comprehensive technical design documents"
        ]
      },
    ]
  },
  { 
    company: "searce inc", 
    title: "cloud engineer", 
    duration: "jun 2020 - may 2022",
    companyDescription: "believer of 'digital transformation is business transformation'. help futurify businesses by leveraging cloud, automation and analytics to innovate faster and better",
    description: [
      "migrated 100+ windows vms for singapore f&b company using sureedge migrator, achieving optimized costs and better performance. implemented devops best practices and configured cloud monitoring dashboards to optimize costs and improve visibility",
      "led gcp migration from aws of 70+ microservices for mnc airline using terraform, gitlab ci, python, and bash automation. implemented cloud backup solutions for resilience and availability",
      "collaborated with google cloud us team on technical blogs, showcasing industry expertise"
    ]
  },
  { 
    company: "techolution", 
    title: "devops engineer intern", 
    duration: "aug 2019 - jun 2020",
    companyDescription: "specializes in developing WOW products & user experiences and delivering: cloud migration, automation, iot, big data & ai managed services/solutions",
    description: [
      "implemented and configured cicd with jenkins for us-based data and ai company, github actions for medical organizations, reducing deployment time by 30%",
      "contributed to in-house products for government and public sector, optimized docker images, improved scripts, and created documentation"
    ]
  },
];

const TECHNOLOGY_LOGOS = [
  { name: "google cloud platform", icon: "devicon-googlecloud-plain", type: "devicon" },
  { name: "amazon web services", icon: "devicon-amazonwebservices-plain-wordmark", type: "devicon" },
  { name: "kubernetes", icon: "devicon-kubernetes-plain", type: "devicon" },
  { name: "docker", icon: "devicon-docker-plain", type: "devicon" },
  { name: "ci/cd", icon: "cloud", category: "cloud" },
  { name: "gitlab ci", icon: "devicon-gitlab-plain", type: "devicon" },
  { name: "cloud build", icon: "build", type: "material" },
  { name: "jenkins", icon: "devicon-jenkins-plain", type: "devicon" },
  { name: "azure devops", icon: "devicon-azuredevops-plain", type: "devicon" },
  { name: "github actions", icon: "devicon-githubactions-plain", type: "devicon" },
  { name: "argocd", icon: "devicon-argocd-plain", type: "devicon" },
  { name: "automation", icon: "autorenew", type: "material" },
  { name: "spacelift", icon: "cloud", type: "material" },
  { name: "gitops", icon: "sync", type: "material" },
  { name: "helm", icon: "devicon-helm-original", type: "devicon" },
  { name: "kustomize", icon: "settings_applications", type: "material" },
  { name: "terraform", icon: "devicon-terraform-plain", type: "devicon" },
  { name: "terragrunt", icon: "layers", type: "material" },
  { name: "python", icon: "devicon-python-plain", type: "devicon" },
  { name: "bash", icon: "devicon-bash-plain", type: "devicon" },
  { name: "observability & monitoring", icon: "visibility", type: "material" },
  { name: "logging & alerting", icon: "notifications_active", type: "material" },
  { name: "prometheus & grafana", icon: "devicon-prometheus-original", type: "devicon" },
  { name: "datadog", icon: "devicon-datadog-plain", type: "devicon" },
  { name: "ansible", icon: "devicon-ansible-plain", type: "devicon" },
  { name: "generative ai", icon: "psychology", type: "material" },
  { name: "chef", icon: "restaurant", type: "material" },
  { name: "server migration", icon: "dns", type: "material" },
  { name: "app migration", icon: "move_to_inbox", type: "material" },
  { name: "database migration", icon: "table_view", type: "material" },
  { name: "database", icon: "storage", type: "material" },
  { name: "technical documentation", icon: "description", type: "material" },
  { name: "consulting", icon: "groups", type: "material" },
  { name: "devops", icon: "all_inclusive", type: "material" },
];

const FAILURES = [
  "started a medium interview series titled silly sit downs with rohan, though i was unable to sustain it beyond the initial few entries due to time constraints, despite having initially committed to continuing it.",
  "got rejected for senior devops engineer role in the last round.",
  "failed mcp server deployment on cloud run demo at devfest armenia due to api keys restrictions, i forgot to unrestrict those plus bad time management.",
  "stupidly spent almost a day troubleshooting a gke cluster issue which could have been easily fixed in 10 minutes if i had read the logs properly",
  "failed ing bank, amsterdam technical round for gcp cloud consultant position",
  "failed to demonstrate a poc of a solution that i proposed to a client",
  "failed to learn snowboarding, will definitely give it another try",
  "failed to master swimming, still have aquaphobia. nonetheless, working on coping with it",
  "over-engineered the terraform for vpn connection from gcp to aws without understanding the ikev2 character limitations and unnecessarily caused migration delay",
  "did hard work and lost weight significantly, then gained it back due to inconsistency and undisciplined behaviour. started the journey again & i have been consistent for the last 2 years",
  "failed interview for razorpay in the technical round, my worst ever performance for a cloud engineer position and one of the hardest 1 hour and 30 minutes of my life",
  "crashed entire terraform pipeline. made a manual change in gke cluster that caused cyclic dependency among the gke components. had to involve my manager and client-side senior devops engineer to fix it",
  "crashed production gke cluster for an important client in my first ever full-time job",
  "lpu had a program where various tasks needed to be performed including selling, dummy startup presentations, team building, sports, assistance, etc. It was my duty to convince the judges in the dummy startup presentation and i failed",
  "failed cloud and devops test in my university. yeah, i started my career with devops only, but somehow i managed to fail in a test conducted by my university for the entire batch",
  "failed to secure a job multiple times in university placement drives. some failures were at technical rounds, some at group discussions, some at coding rounds, some at hr interviews, etc.",
  "failed oracle database sql exam (1z0-071) and lost the internship opportunity",
  "failed first driving license test",
  "failed to clear exam for tolani maritime university for marine engineering, this time cleared maths but failed in physics by 5 marks",
  "failed to clear exam for indian air force pilot",
  "lost a school-level cricket cup under my captaincy, stupid decisions, senior ego and worst batter",
  "failed mathematics and chemistry multiple times in school, some of scores that i call recall 11/100, 21/100, 2/50, 8/25, and the list goes on",
];

const ARTICLES_AND_TALKS = {
  articles: [
    {title: "building an earthquake watch api platform with apigee x and cloud run", meta: "build an api platform for real-time earthquake monitoring using google apigee x, cloud run, and pub/sub, featuring pro & free tier-one backend two products, production-ready tools, automated deployments, and event-driven architecture.", link: "https://medium.com/google-cloud/building-an-earthquake-watch-api-platform-with-apigee-x-and-cloud-run-79cd858cbd62"},
    {title: "autonomous iam privilege chain hunter and least privilege refactorer for gcp organizations using antigravity", meta: "a gcp-based autonomous antigravity-based agent that discovers privilege chains, identifies privilege escalation risks, and automatically refactors iam policies to enforce least privilege, using an evaluation harness and the open-source gcp-security-tools repository to validate findings.", link: "https://medium.com/google-cloud/autonomous-iam-privilege-chain-hunter-least-privilege-refactorer-for-gcp-organizations-06febb9d6b55"},
    {title: "secure ai applications with model armor and sensitive data protection (sdp)", meta: "a blog to demonstrate how to secure and shield agentic ai running on vertex ai from a variety of attacks using gcp model armor and sensitive data protection (dlp).", link: "https://medium.com/google-cloud/secure-ai-applications-with-model-armor-and-sensitive-data-protection-sdp-8451e54a52f9"},
    { title: "building an autonomous infra agent using vertex ai, adk, and google managed remote mcp", meta: "design an autonomous infra sre agent using the agent development kit (adk) and the newly released gcp managed mcp server for gce, and deploy it on the vertex ai agent engine.", link: "https://medium.com/google-cloud/building-an-autonomous-infra-agent-using-vertex-ai-adk-and-google-managed-remote-mcp-e80e657ac67e"},
    { title: "deploy mcp server on gcp cloud run", meta: "deployment of the mcp server on gcp cloud run. this mcp server utilizes the google maps, openweather, and iqair api to retrieve the information. the mcp server features 9 production-level tools, including prompts, caching, and error handling, and utilizes fastmcp.", link: "https://medium.com/google-cloud/deploy-mcp-server-on-gcp-cloud-run-d85bb7681f44" },
    { title: "private service access (psa) vs private service connect (psc) vs private google access (pga) — made simple", meta: "a blog covering and explaining the differences among private service access vs private service connect vs private google access in technical language, as well as with a simple analogy.", link: "https://medium.com/google-cloud/private-service-access-psa-vs-private-service-connect-psc-vs-private-google-access-pga-50e1125ed83a" },
    { title: "building a gitlab ci/cd pipeline for a monorepo - the normal way", meta: "an article that demonstrates how to leverage gitlab ci for monorepo app deployment on gcp cloud run using jib, leverages templates, and authentication using wif.", link: "https://medium.com/google-cloud/building-a-gitlab-ci-cd-pipeline-for-a-monorepo-normal-way-cfc058f3a0b7" },
    { title: "configure gcp workload identity federation for gitlab", meta: "this tutorial is about setting up gcp workload identity federation for gitlab and securing pipelines with ephemeral, fine-grained sa impersonation.", link: "https://medium.com/google-cloud/configure-gcp-workload-identity-federation-for-gitlab-c526e6eb0517" },
    { title: "gcp workflows for gcp filestore-backup automation", meta: "use gcp workflows to automate the gcp filestore backup and retention for the last 7 days in a declarative fashion (YAML) for multiple filestore instances.", link: "https://medium.com/google-cloud/gcp-workflows-for-gcp-filestore-backup-automation-c09299abcd6a" },
    { title: "revolutionize the internal search engine with google agentspace", meta: "discover the power of google agentspace for enterprise. explore how ai-driven internal search and knowledge management can empower your enterprise and departments.", link: "https://medium.com/google-cloud/revolutionize-the-internal-search-engine-with-google-agentspace-d108079ba334" },
    { title: "enabling enterprise-grade migration across cloud providers — achieving network transitivity on an enterprise scale in gcp", meta: "a detailed overview of achieving & enhancing cross-cloud network connectivity enabling transitive network characteristics using Interconnect for large enterprises.", link: "https://medium.com/google-cloud/enabling-enterprise-grade-migration-across-cloud-providers-achieving-network-transitivity-on-an-dec32ea801b5" },
    { title: "cloud build + cloud deploy: best siblings", meta: "automate your application deployment on cloud run using gcp cloud build and cloud deploy and promote the stable release from stage to prod using the stable image.", link: "https://medium.com/google-cloud/cloud-build-cloud-deploy-best-siblings-b591b4e7aff" },
    { title: "create a read replica of an external source/master (aws) in gcp cloudsql", meta: "create and run a read replica of external db source (aws) in gcp cloudSQL using gcp database migration service and further add additional read replica under the same source representation.", link: "https://medium.com/google-cloud/create-a-read-replica-of-an-external-source-master-aws-in-gcp-cloudsql-using-gcp-database-d8530dd86aed" },
    { title: "access secrets from secret manager using berglas", meta: "access secrets stored in google secret manager/cloud storage via berglas for applications running on google kubernetes engine.", link: "https://faun.pub/access-secrets-from-secret-manager-using-berglas-b30e73a5980a" },
    { title: "access gcp resources from gke via workload identity", meta: "how to access cloud sql dB username and password secrets stored in secret manager from applications deployed on google kubernetes engine. Connection to cloudsql is via cloud sql proxy.", link: "https://medium.com/google-cloud/access-gcp-resources-from-gke-via-workload-identity-152dc1a86926" },
    { title: "using slack to automate manual approvals in google cloud build", meta: "this solution shows how you can achieve and automate manual approval in cloud build via slack to avoid any abruption.", link: "https://faun.pub/using-slack-to-automate-manual-approvals-in-google-cloud-build-33de00be6a89" },
    { title: "using pre-scripts in vm manager to patch gcp vms (os patch management)", meta: "create disk snapshots or clone or gmi before gce vms (windows & linux ) are getting patched via gcp vm manager patch management using pre-patch scripts.", link: "https://blog.searce.com/patching-gce-vms-using-gcp-vm-manager-os-patch-management-a27eba7d356f" },
    { title: "build machine images with packer on google cloud platform", meta: "packer is an open-source, lightweight, highly performant tool created by hashicorp. i'm building google compute instance vm custom machine image using provisioners and post-provisioners.", link: "https://blog.searce.com/build-machine-images-with-packer-on-google-cloud-platform-b43f77f1acd" },
    { title: "automate and deploy springboot app as a service in gce vm", meta: "automate the deployment of springBoot application on compute engine instance as a ubuntu service using gitlab ci/cd tool", link: "#https://blog.searce.com/automate-and-deploy-springboot-app-as-a-service-in-gce-vm-ca2baa2fb4b1" },
    { title: "automating terraform with github actions", meta: "automating gcp resources provisioning with terraform via github actions. terraform plan generates a plan file which is further used by terraform apply. this is done to prevent uninformed changes b/w plan and apply.", link: "https://blog.searce.com/automating-terraform-with-github-actions-5b3aac5abea7" },
    { title: "firebase continuous integration and deployment (ci/cd) with google cloud build", meta: "firebase continuous integration and deployment (ci/cd) with google cloud build. I will be walking you through the ci/cd of firebase with google cloud.", link: "https://faun.pub/firebase-continous-integration-and-deployment-ci-cd-with-google-cloud-build-78ada9333cb9" },
    { title: "multibranch and ha pipeline in jenkins with kaniko on gke", meta: "create multibranch and ha pipeline in jenkins with kaniko on gke to have a scale, resource-utilized and scalable pipeline.", link: "https://blog.searce.com/multibranch-and-ha-pipeline-in-jenkins-with-kaniko-on-gke-8a1e7fa93403" },
    { title: "secure and backup mongodb on google cloud platform", meta: "learn the ways you can secure and backup mongodb on gcp.", link: "https://faun.pub/secure-and-backup-mongodb-on-google-cloud-platform-4c242669d58e" },
    { title: "automate anything with google cloud functions and cloud build", meta: "understand how powerful can be google cloud functions and cloud build to automate anything, and reduce overhead management.", link: "https://faun.pub/automate-anything-with-google-cloud-functions-and-cloud-build-85fc4fec7388" },
    { title: "application deployment with azure kubernetes service and azure pipelines", meta: "design a full application deployment pipeline to deploy apps on azure kubernetes service using azure pipelines.", link: "https://faun.pub/application-deployment-with-azure-kubernetes-service-and-azure-pipelines-a0bf43916746" },
    { title: "google cloud memorystore with nodejs on google kubernetes engine", meta: "how to set up google memorystore in gcp and integrate it with nodejs app", link: "https://faun.pub/google-cloud-memorystore-with-node-js-on-google-kubernetes-engine-c9aa13721268" },
    { title: "installing wordpress on gke with cloud sql", meta: "learn how to install and set up wordpress on gke with cloud sql.", link: "https://faun.pub/installing-wordpress-on-gke-with-cloud-sql-7cb104dcff04" },
    { title: "setting up jenkins on google kubernetes engine with helm", meta: "learn how to leverage helm to set up jenkins on google kubernetes engine.", link: "https://faun.pub/jenkins-on-google-kubernetes-engine-gke-with-helm-a74c12cb7e64" },
    { title: "ci/cd with jenkins on google compute engine (gcp)", meta: "learn how to set up jenkins on google compute engine (gcp) to perform ci/cd.", link: "https://faun.pub/jenkins-on-google-compute-engine-611bd86e295b" },
    { title: "storage in cloud", meta: "learn the ways you can store data in cloud. comparison b/w gcp and aws storage service.", link: "https://medium.com/codingurukul/storage-in-cloud-6b49f87a0032" },
    { title: "security architecture of aws cognito", meta: "learn the security architecture of aws cognito.", link: "https://medium.com/codingurukul/security-architecture-of-aws-cognito-bb05d1038ecc" },
    { title: "game deployment and development in cloud", meta: "understand what aws service will need in order to deploy a game with the help of AWS. there are no workflows in this,", link: "https://medium.com/codingurukul/game-deployment-and-development-in-cloud-d3bf05c1046e" },
  ],
  nonTechArticles: [
    { title: "silly sit-downs with rohan (ssd-07): an interview with jyoti prasad patri, advocate at odisha high court", link: "https://rohankalhans.medium.com/silly-sit-downs-with-rohan-ssd-07-an-interview-with-jyoti-prasad-patri-advocate-at-odisha-high-acfc179a153f" },
    { title: "silly sit-downs with rohan (ssd-06): an interview with shashank mangal, security researcher at microsoft", link: "https://rohankalhans.medium.com/silly-sit-downs-with-rohan-ssd-06-an-interview-with-shashank-mangal-security-researcher-at-d007a699a64d" },
    { title: "silly sit-downs with rohan (ssd-05): an interview with miles ward, chief technology officer (cto) at sada systems", link: "https://rohankalhans.medium.com/silly-sit-downs-with-rohan-ssd-05-an-interview-with-miles-ward-chief-technology-officer-cto-45cf2502f03b" },
    { title: "silly sit-downs with rohan (ssd-04): an interview with sohail pathan, developer advocate at apyhub", link: "https://rohankalhans.medium.com/silly-sit-downs-with-rohan-ssd-04-an-interview-with-sohail-pathan-developer-advocate-at-apyhub-dfdb3415d1bf" },
    { title: "silly sit-downs with rohan (ssd-03): an interview with sneh pandya, product manager at mantra labs global", link: "https://rohankalhans.medium.com/silly-sit-downs-with-rohan-ssd-03-an-interview-with-sneh-pandya-product-manager-at-mantra-labs-f223b7b5f719" },
    { title: "silly sit-downs with rohan (ssd-02): an interview with aditya raj, senior devops engineer at srijan technologies", link: "https://rohankalhans.medium.com/silly-sit-downs-with-rohan-ssd-02-an-interview-with-aditya-raj-senior-devops-engineer-at-3512030254dc" },
    { title: "silly sit-downs with rohan (ssd-01): an interview with pranay nanda, customer engineer at google", link: "https://rohankalhans.medium.com/silly-sit-downs-with-rohan-ssd-01-an-interview-with-pranay-nanda-customer-engineer-at-google-16f66f4dc593" },
    { title: "life at gdg jalandhar", link: "https://medium.com/gdg-jalandhar/life-at-gdg-jalandhar-f7c36583060b" },
    { title: "my journey at gdg jalandhar", link: "https://rohankalhans.medium.com/my-journey-at-gdg-jalandhar-544178cb006e" },
  ],
  talks: [
    { title: "the dual engines of enterprise ai: deployment and orchestration on vertex ai & cloud run", meta: "jun, 2026 | gdg yerevan", link: "https://docs.google.com/presentation/d/100EFNW0BXiLE7BFyksNiWmYMiTr5L0Zyo_iTuYnjh3I/edit?usp=sharing"},
    { title: "accelerate ai with cloud run: deploy mcp server on gcp cloud run", meta: "dec, 2025 | devfest yerevan", link: "https://docs.google.com/presentation/d/1rjpjC88-oWkaCvWXbpDq4HziB17T4Q_iU_MAZcGNglg/edit?usp=sharing"},
    { title: "gitops: the future of deployment, deployed", meta: "apr, 2025 | ardy academy, yerevan", link: "https://docs.google.com/presentation/d/1LG5flJbm4aji9kfvp47ezhOQx9B0qxzy81ANl0EnUDU/edit?usp=sharing"},
    { title: "gke enterprise: do we need it or not.", meta: "nov, 2024 | devfest ahmedabad", link: "https://docs.google.com/presentation/d/1BLNSusrCzfs6BuO6G2H8ysp51tWSTpDNIkYfCTq7twI/edit?usp=sharing"},
    { title: "gke enterprise: do we need it or not.", meta: "oct, 2024 | devfest yerevan", link: "https://docs.google.com/presentation/d/1E85eO7-bs1oVpy5DJ7XGDG5rtBQ75w0k_Uzexjw3LH0/edit?usp=sharing"},
    { title: "let's talk about observability in google cloud platform", meta: "sep, 2024 | gdg yerevan", link: "https://docs.google.com/presentation/d/1W92I3pxQv9mlZh731XHxj3IZ7u3qid95-gjRRcvNYDc/edit?usp=sharing"},
    { title: "optimization and secure gcp infrastructure", meta: "oct, 2023 | gdg yerevan", link: "https://docs.google.com/presentation/d/11EEM3P6GL1QKZGZUnIwcHVk0kmZFRKGB_mckJuh_OJw/edit?usp=sharing" },
    { title: "developers day 2021", meta: "feb, 2021 | gdg jalandhar", link: "https://youtu.be/ooyZfIuMfAs?t=1006" },
    { title: "what’s new in google compute services", meta: "aug, 2020 | gdg nagpur", link: "https://youtu.be/jQEOBQgRAWI?t=70" },
    { title: "google compute services", meta: "apr, 2020 | gdg jalandhar", link: "https://youtu.be/ZUm_8nc8mfI?t=2000" },
    { title: "actions on google", meta: "jun, 2019 | coding blocks", link: "https://docs.google.com/presentation/d/1vYBGDP-Wzz8QQ-7JMTiTdXsNpOK2J4TNMu6GgGsaalk/edit?usp=sharing" },
    { title: "google kubernetes engine", meta: "may, 2019 | gdg jalandhar", link: "https://docs.google.com/presentation/d/1OZUuoCzMDlRqLzwel3Gyom82L3tWhNic8RH7OiwmV3E/edit?usp=sharing" },
    { title: "docker and containers", meta: "may, 2019 | lovely professional university", link: "https://docs.google.com/presentation/d/1YRGZ61-34gTWMlloNM3oTmBXZONff1gfKkY_1tU6-zU/edit?usp=sharing" },
    { title: "orchestrating the cloud with kubernetes", meta: "apr, 2019 | gdg cloud new delhi", link: "https://docs.google.com/presentation/d/1ClEeDoKWV8Rt_l1ALcrqicMaBmK3x4ObCpKXQax7r7E/edit?usp=sharing" },
    { title: "vector prime-actions on google", meta: "oct, 2018 | gdg devfest Bengaluru", link: "https://docs.google.com/presentation/d/1oBs_Ts_VZ81p-U_h-e32YZKA6vEba8vJtxJSyM5zrrU/edit?usp=sharing" },
    { title: "cloud computing-beginners guide", meta: "feb, 2018 | gdg jalandhar", link: "https://docs.google.com/presentation/d/1T_31hkVSf1ymZMIG3rhSgEsXAInWXpY9kbpZMhO-cWY/edit?usp=sharing" },
  ],
};
const TECH_ARTICLES_PER_PAGE = 6;
const NON_TECH_ARTICLES_PER_PAGE = 10;
const TALKS_PER_PAGE = 6;
const CERTIFICATIONS_PER_PAGE = 5;
const ACHIEVEMENTS_PER_PAGE = 6;
const FAILURES_PER_PAGE = 6;


// --- UTILITY COMPONENTS ---

// Custom Material Icon Component
const MaterialIcon = ({ iconName, className = '', filled = true, isSymbol = false }) => (
    <i className={`${isSymbol ? 'material-symbols-outlined' : 'material-icons'} ${filled && !isSymbol ? 'material-icons-filled' : ''} ${className}`}>
        {iconName}
    </i>
);

// Scroll Animation Component
const ScrollFadeIn = ({ children, delay = 0, direction = 'up', className = '' }) => {
    const ref = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const currentRef = ref.current;
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            },
            { threshold: 0.1 } // Trigger when 10% of the element is visible
        );

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    let animationClass = 'opacity-0 transform';
    if (isVisible) {
        if (direction === 'up') animationClass = 'animate-slide-up';
        else if (direction === 'left') animationClass = 'animate-slide-left';
        else if (direction === 'right') animationClass = 'animate-slide-right';
        else animationClass = 'animate-fade-in-slow';
    }

    return (
        <div 
            ref={ref} 
            className={`${animationClass} ${className}`}
            style={{ transitionDelay: `${delay}ms` }}
        >
            {children}
        </div>
    );
};

const SectionContainer = ({ children, title, subtitle, className = '', isDark = true }) => (
  <section className={`py-16 md:py-20 px-4 md:px-8 ${isDark ? 'bg-black text-white' : 'bg-white text-gray-900'} ${className}`}>
    <div className="max-w-7xl mx-auto">
      {title && (
        <ScrollFadeIn direction="up">
          <h2 className={`text-3xl font-extrabold font-heading ${isDark ? 'text-white' : 'text-gray-900'} border-b-2 border-orange-500 inline-block pb-1 mb-2 lowercase`}>
            {title}
          </h2>
          {subtitle && <p className="text-lg text-gray-400 mb-10 font-body lowercase">{subtitle}</p>}
        </ScrollFadeIn>
      )}
      {children}
    </div>
  </section>
);

const ArticleItem = ({ title, meta, link, isTalk = false }) => (
  <a href={link} target="_blank" rel="noopener noreferrer" 
     className="interactive-element block group p-4 border-b border-gray-800 hover:bg-gray-800 transition-colors duration-200 rounded-lg -mx-4 hover:scale-[1.01] transform transition-transform"
  >
    <div className="flex items-center justify-between">
        <div className="flex items-start">
            <MaterialIcon 
                iconName={isTalk ? "mic" : "article"} 
                className="text-2xl text-orange-500 group-hover:text-orange-400 mr-4 mt-0.5 flex-shrink-0 transition-transform duration-200" 
            />
            <div>
                <h4 className="text-xl font-semibold leading-snug font-heading text-white group-hover:text-orange-400 transition-colors duration-200 lowercase">{title}</h4>
                {meta && <p className="text-sm text-gray-400 mt-1 font-body lowercase">{meta}</p>}
            </div>
        </div>
        <MaterialIcon iconName="arrow_forward" className="text-2xl text-gray-600 group-hover:text-orange-400 transition-transform duration-200 group-hover:translate-x-1" />
    </div>
  </a>
);

const CallToActionButton = ({ children, className = '', iconName, isSymbol = false, ...props }) => (
    <button
        className={`interactive-element group flex items-center justify-center px-6 py-3 rounded-lg transition duration-300 shadow-md sora-regular transform hover:scale-[1.02] hover:shadow-lg ${className} lowercase`}
        {...props}
    >
        {iconName && <MaterialIcon iconName={iconName} isSymbol={isSymbol} className="text-xl mr-2 transition-transform duration-300 group-hover:rotate-6" />}
        {children}
    </button>
);

// --- PAGINATION COMPONENT ---

const PaginatedList = ({ items, itemsPerPage, ItemComponent, isTalk = false, listId }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(items.length / itemsPerPage);
    const uniqueId = listId || (isTalk ? 'talks-list' : 'articles-list');

    const startIndex = (currentPage - 1) * itemsPerPage;
    const currentItems = items.slice(startIndex, startIndex + itemsPerPage);

    const paginate = (pageNumber) => {
        if (pageNumber > 0 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
            // Scroll to the top of the list when changing pages for better UX
            const listElement = document.getElementById(uniqueId);
            if (listElement) listElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="flex flex-col">
            <div id={uniqueId} className="flex flex-col space-y-2 mb-8">
                {currentItems.map((item, index) => (
                    <ItemComponent key={index} {...item} isTalk={isTalk} />
                ))}
            </div>

            {totalPages > 1 && (
                <div className="flex justify-center items-center space-x-2 text-white interactive-element">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="p-2 rounded-full transition-colors duration-200 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-gray-800 transform hover:scale-105 interactive-element sora-regular"
                    >
                        <MaterialIcon iconName="chevron_left" className="text-2xl text-orange-500" />
                    </button>

                    {[...Array(totalPages).keys()].map(index => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={`px-4 py-2 rounded-full sora-regular transition-colors duration-200 transform hover:scale-105 interactive-element ${
                                currentPage === index + 1 ? 'bg-orange-600 text-white' : 'bg-gray-800 hover:bg-gray-700 text-gray-300'
                            }`}
                        >
                            {index + 1}
                        </button>
                    ))}

                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="p-2 rounded-full transition-colors duration-200 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-gray-800 transform hover:scale-105 interactive-element sora-regular"
                    >
                        <MaterialIcon iconName="chevron_right" className="text-2xl text-orange-500" />
                    </button>
                </div>
            )}
        </div>
    );
};

// --- MOUSE FOLLOWER COMPONENT ---
const MouseFollower = () => {
    const followerRef = useRef(null);
    const mousePos = useRef({ x: -100, y: -100 });
    const currentPos = useRef({ x: -100, y: -100 });

    useEffect(() => {
        const handleMouseMove = (e) => {
            mousePos.current = { x: e.clientX, y: e.clientY };
            
            // Check for interactive elements immediately for responsive hover state
            const target = e.target.closest('.interactive-element');
            if (followerRef.current) {
                if (target) {
                    followerRef.current.style.width = '50px';
                    followerRef.current.style.height = '50px';
                    followerRef.current.style.opacity = '0.5';
                    followerRef.current.style.mixBlendMode = 'difference'; 
                } else {
                    followerRef.current.style.width = '20px';
                    followerRef.current.style.height = '20px';
                    followerRef.current.style.opacity = '1';
                    followerRef.current.style.mixBlendMode = 'normal';
                }
            }
        };

        window.addEventListener('mousemove', handleMouseMove);

        let animationFrameId;

        const animate = () => {
            if (followerRef.current) {
                const BLEND_FACTOR = 0.15; // Slightly increased for better responsiveness while keeping smoothness
                
                const targetX = mousePos.current.x - 10; // Adjust for follower size
                const targetY = mousePos.current.y - 10;
                
                // Linear interpolation (lerp)
                currentPos.current.x += (targetX - currentPos.current.x) * BLEND_FACTOR;
                currentPos.current.y += (targetY - currentPos.current.y) * BLEND_FACTOR;

                followerRef.current.style.transform = `translate3d(${currentPos.current.x}px, ${currentPos.current.y}px, 0)`;
            }
            animationFrameId = requestAnimationFrame(animate);
        };

        animate();

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <div 
            ref={followerRef} 
            className="mouse-follower bg-orange-500 rounded-full fixed top-0 left-0 z-[9999] pointer-events-none transition-[width,height,opacity] duration-200 ease-out will-change-transform" 
        />
    );
};


// --- CONTENT BLOCK COMPONENTS ---

const CareerHistoryContent = () => {
    const [expandedPositions, setExpandedPositions] = useState({ '0-0': true }); // Expand senior cloud platform engineer by default

    const togglePosition = (key) => {
        setExpandedPositions(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    return (
        <ScrollFadeIn direction="up" className="lg:w-1/2">
            <h3 className="text-2xl font-bold font-heading text-white flex items-center mb-6 lowercase">
                <MaterialIcon iconName="work" className="text-3xl text-orange-600 mr-3"/> career journey (5+ years)
            </h3>
            <ol className="relative border-l-4 border-gray-800 space-y-10 pl-6">
                {CAREER_HISTORY.map((job, index) => (
                    <ScrollFadeIn key={index} direction="up" delay={index * 150} className="relative pt-1">
                        <span className="absolute w-4 h-4 bg-orange-600 rounded-full -left-8 top-4 border-4 border-black"></span>
                        {job.positions ? (
                            // Company with multiple positions (grouped)
                            <div className="interactive-element hover:scale-[1.01] transition-transform p-3 hover:bg-gray-800 rounded transition-colors duration-200">
                                <h4 className="text-xl font-semibold font-heading text-white lowercase mb-1">{job.company}</h4>
                                <time className="block text-orange-600 mb-4 font-body lowercase" style={{fontSize: '0.875rem'}}>{job.duration}</time>
                                <div className="ml-4 space-y-4 border-l-2 border-gray-700 pl-4">
                                    {job.positions.map((position, posIndex) => {
                                        const posKey = `${index}-${posIndex}`;
                                        const isExpanded = expandedPositions[posKey];
                                        return (
                                            <div key={posIndex} className="relative">
                                                <span className="absolute w-2 h-2 bg-gray-500 rounded-full -left-[21px] top-2"></span>
                                                <div className="flex items-center gap-2">
                                                    <button
                                                        onClick={() => togglePosition(posKey)}
                                                        className="text-orange-500 hover:text-orange-400 transition-colors duration-200 interactive-element flex-shrink-0"
                                                    >
                                                        <MaterialIcon iconName={isExpanded ? "expand_less" : "chevron_right"} className="text-lg" />
                                                    </button>
                                                    <h5 className="text-lg font-medium font-heading text-gray-100 lowercase">{position.title}</h5>
                                                </div>
                                                <time className="block text-xs text-orange-500 mb-2 font-body lowercase ml-7">{position.duration}</time>
                                                
                                                {isExpanded && (
                                                    <ul className="list-disc list-inside space-y-1 text-gray-300 text-sm font-body lowercase ml-7 mb-2">
                                                        {position.description.map((point, pointIndex) => (
                                                            <li key={pointIndex}>{point}</li>
                                                        ))}
                                                    </ul>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                                {job.companyDescription && (
                                    <p className="text-sm text-gray-400 font-body lowercase mt-4 italic">{job.companyDescription}</p>
                                )}
                            </div>
                        ) : (
                            // Single position
                            <div className="interactive-element hover:scale-[1.01] transition-transform p-3 hover:bg-gray-800 rounded transition-colors duration-200">
                                <h4 className="text-xl font-semibold font-heading text-white lowercase mb-2">{job.company}</h4>
                                <div className="flex items-center gap-2">
                                    <button
                                        onClick={() => togglePosition(`single-${index}`)}
                                        className="text-orange-500 hover:text-orange-400 transition-colors duration-200 interactive-element flex-shrink-0"
                                    >
                                        <MaterialIcon iconName={expandedPositions[`single-${index}`] ? "expand_less" : "chevron_right"} className="text-lg" />
                                    </button>
                                    <h5 className="text-lg font-medium font-heading text-gray-100 lowercase">{job.title}</h5>
                                </div>
                                <time className="block text-xs text-orange-500 mb-2 font-body lowercase ml-7">{job.duration}</time>
                                {job.companyDescription && (
                                    <p className="text-sm text-gray-400 font-body lowercase mb-2 italic ml-7">{job.companyDescription}</p>
                                )}
                                
                                {expandedPositions[`single-${index}`] && (
                                    <ul className="list-disc list-inside space-y-1 text-gray-300 text-sm font-body lowercase ml-7 mb-2">
                                        {job.description.map((point, pointIndex) => (
                                            <li key={pointIndex}>{point}</li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        )}
                    </ScrollFadeIn>
                ))}
            </ol>
        </ScrollFadeIn>
    );
};

const CERTIFICATIONS = [
  { name: "generative ai leader", issuer: "google cloud", link: "https://www.credly.com/badges/6c6298d2-50ca-462e-9c09-47b10c07c5c6/public_url" },
  { name: "associate ai infrastructure and operations", issuer: "nvidia", link: "https://www.credly.com/badges/2c7cab6d-7e2f-4c78-ac61-76ab78f072c3/public_url" },
  { name: "solutions associate - associate", issuer: "amazon web services", link: "https://www.credly.com/badges/4baddaf1-80bc-4bb0-bd13-2ddb19d2f4ee" },
  { name: "vault associate (002)", issuer: "hashicorp", link: "https://www.credly.com/badges/9e3603ff-f252-451e-9511-8f971e50bb1d/linked_in_profile" },
  { name: "associate cloud engineer", issuer: "google cloud", link: "https://www.credly.com/badges/f52a15c7-8e52-4305-9906-59548b73699c/public_url" },
  { name: "professional cloud security engineer", issuer: "google cloud", link: "https://www.credly.com/badges/4e0590b5-d8ee-451d-b287-1a88b6962c6d/public_url" },
  { name: "professional cloud architect", issuer: "google cloud", link: "https://www.credly.com/badges/9b7f5bd3-2927-4073-95c1-48d699554684/public_url" },
  { name: "terraform associate (002)", issuer: "hashicorp", link: "https://www.credly.com/badges/04f6aef4-dacb-4a0d-9064-7415a60295e5/public_url" },
  { name: "google skills", issuer: "google cloud", link: "https://www.skills.google/public_profiles/d0839fc2-fe35-4481-8ca1-a709ee9a52a9" },
];

const KEY_ACHIEVEMENTS = [
  "featured in google duetai video talking about duet ai and how it is assisting us in day-to-day work",
  "featured in google cloud next 2023 developer keynote alongside fellow google cloud champion innovators talking about legacy apps and engineering",
  "mini documentary - google cloud success story featuring me, aired on google cloud's official youtube channel by google cloud success story",
  "invited as a google kubernetes speaker by google cloud developer community new delhi",
  "honoured with guest of honor by apeejay institute of management technical campus as Young Motivators",
  "most active campus ambassador of punjab by coding blocks",
  "winner of india builds actions campaign under Actions on Google by google india",
  "5th position at sap next gen hackathon by sap",
  "campus ambassador of the month by coding blocks",
  "google india scholarship under mobile skilling program by udacity",
  "finalist of microsoft hackathon1.0 by microsoft technical club lpu",
];

const CertificationItem = ({ name, issuer, link }) => (
    <div className="lowercase group interactive-element p-3 hover:bg-gray-800 rounded transition-colors duration-200">
        <a 
            href={link} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="flex items-start -mx-2 p-2"
        >
            <MaterialIcon iconName="workspace_premium" className="text-lg text-gray-500 mr-2 mt-0.5 group-hover:text-orange-500 transition-colors" />
            <div>
                <span className="block text-white font-medium group-hover:text-orange-400 transition-colors flex items-center">
                    {name}
                    <MaterialIcon iconName="open_in_new" className="text-xs ml-2 opacity-0 group-hover:opacity-100 transition-opacity text-gray-400" />
                </span>
                <span className="text-xs text-gray-500 font-body">{issuer}</span>
            </div>
        </a>
    </div>
);

const CertificationsContent = () => (
    <div className="mt-6">
        <h4 className="font-semibold text-lg font-heading text-white lowercase flex items-center mb-4">
            <MaterialIcon iconName="verified" className="text-xl text-orange-600 mr-2"/> certifications
        </h4>
        <div className="space-y-3">
             <PaginatedList 
                items={CERTIFICATIONS} 
                itemsPerPage={CERTIFICATIONS_PER_PAGE} 
                ItemComponent={CertificationItem} 
                listId="certifications-list"
            />
        </div>
    </div>
);

const CommunityExperienceContent = () => (
    <ScrollFadeIn direction="right" delay={200} className="lg:w-1/2 lg:pl-10">
        <h3 className="text-2xl font-bold font-heading text-white flex items-center mb-6 lowercase">
            <MaterialIcon iconName="campaign" className="text-3xl text-orange-600 mr-3"/> community experience
        </h3>
        <ul className="space-y-4 text-gray-300 font-body">
            <li className='lowercase interactive-element p-3 hover:bg-gray-800 rounded transition-colors duration-200'>
                <span className="block text-white">google developer expert - google cloud</span>
                <span className="block text-sm text-orange-600 font-body">mar, 2025 - present</span>
            </li>
            <li className='lowercase interactive-element p-3 hover:bg-gray-800 rounded transition-colors duration-200'>
                <span className="block text-white">co-organizer - google developers group yerevan</span>
                <span className="block text-sm text-orange-600 font-body">sep, 2024 - present</span>
            </li>
            <li className='lowercase interactive-element p-3 hover:bg-gray-800 rounded transition-colors duration-200'>
                <span className="block text-white">google cloud champion innovator - modern architecture</span>
                <span className="block text-sm text-orange-600 font-body">jan, 2023 - mar, 2025</span>
            </li>
            <li className='lowercase interactive-element p-3 hover:bg-gray-800 rounded transition-colors duration-200'>
                <span className="block text-white">technical core member - google developers group jalandhar</span>
                <span className="block text-sm text-orange-600 font-body">sep, 2017 - jan, 2020</span>
            </li>
            <li className='lowercase interactive-element p-3 hover:bg-gray-800 rounded transition-colors duration-200'>
                <span className="block text-white">campus ambassador - coding blocks</span>
                <span className="block text-sm text-orange-600 font-body">may, 2018 - july, 2019</span>
            </li>
        </ul>
        <CertificationsContent />
    </ScrollFadeIn>
);

const AchievementItem = ({ item }) => (
    <li className='lowercase'>{item}</li>
);



const KeyAchievementsContent = () => (
    <ScrollFadeIn direction="up">
        <div className="interactive-element p-6 bg-gray-900 rounded-xl hover:bg-gray-800 transition-colors duration-200 h-full border border-gray-800">
            <h3 className="text-2xl font-bold font-heading text-white flex items-center mb-6 lowercase">
                <MaterialIcon iconName="emoji_events" className="text-3xl text-orange-600 mr-3"/> key achievements
            </h3>
            <ul className="list-disc list-inside space-y-3 text-gray-300 font-body ml-2">
                 <PaginatedList 
                    items={KEY_ACHIEVEMENTS.map(text => ({ text }))} 
                    itemsPerPage={ACHIEVEMENTS_PER_PAGE} 
                    ItemComponent={({ text }) => <li className='lowercase'>{text}</li>}
                    listId="achievements-list"
                />
            </ul>
        </div>
    </ScrollFadeIn>
);

const FailureItem = ({ item }) => (
    <li className='lowercase text-gray-300 font-body leading-relaxed'>{item}</li>
);

const WinsAndLessonsSection = () => (
    <SectionContainer title="wins & lessons" subtitle="celebrating victories and learning from defeats." isDark={true}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <KeyAchievementsContent />
            <ScrollFadeIn direction="up" delay={200}>
                <div className="interactive-element p-6 bg-gray-900 rounded-xl hover:bg-gray-800 transition-colors duration-200 h-full border border-gray-800">
                    <h3 className="text-2xl font-bold font-heading text-white flex items-center mb-6 lowercase">
                        <MaterialIcon iconName="psychology" className="text-3xl text-orange-600 mr-3"/> failures
                    </h3>
                    <ul className="list-disc list-inside space-y-3 ml-2">
                        <PaginatedList 
                            items={FAILURES.map(text => ({ item: text }))} 
                            itemsPerPage={FAILURES_PER_PAGE} 
                            ItemComponent={FailureItem} 
                            listId="failures-list"
                        />
                    </ul>
                </div>
            </ScrollFadeIn>
        </div>
    </SectionContainer>
);

// --- TECHNOLOGY LOGOS SECTION CONTENT (MODIFIED FOR FLUID SCROLL) ---
const TechnologyLogosContent = () => {
    const scrollRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (!scrollContainer) return;

        let animationFrameId;

        const scroll = () => {
            if (!isPaused) {
                // If we've scrolled past the first set of items (halfway), reset to 0 to loop
                // We use >= here to catch it, but resetting to 1 or 0 creates the loop.
                // The content is triplicated, so resetting to 0 when we reach 1/3 or 1/2 way is safe.
                // Let's assume we duplicate it 3 times. When we reach the end of the 1st set, we jump back.
                // However, simpler logic: just keep scrolling. If scrollLeft + clientWidth >= scrollWidth, reset.
                // But for a seamless loop, we usually reset when we've scrolled exactly the width of one set.
                
                // Let's rely on a simpler "infinite" check:
                if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
                    scrollContainer.scrollLeft = 0;
                } else {
                    scrollContainer.scrollLeft += 1; // Adjust speed: 1px per frame is 60px/sec (approx)
                }
            }
            animationFrameId = requestAnimationFrame(scroll);
        };

        animationFrameId = requestAnimationFrame(scroll);

        return () => cancelAnimationFrame(animationFrameId);
    }, [isPaused]);

    return (
        <ScrollFadeIn direction="up">
            <div className="py-12 relative">
                <div 
                    ref={scrollRef}
                    className="flex flex-nowrap overflow-x-auto pb-8 pt-4 space-x-6 scrollbar-hide cursor-grab active:cursor-grabbing"  
                    style={{ scrollBehavior: 'auto' }}
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                >
                    {/* Triplicate to ensure smooth infinite scrolling even on large screens */}
                    {[...TECHNOLOGY_LOGOS, ...TECHNOLOGY_LOGOS, ...TECHNOLOGY_LOGOS].map((tech, index) => (
                        <div 
                            key={index} 
                            className="flex-shrink-0 flex flex-row items-center justify-center px-6 py-3 mx-4 group interactive-element transform hover:scale-105 transition-all duration-300 bg-gray-900/50 border border-gray-800 rounded-full hover:border-orange-500/50 hover:bg-gray-800 hover:shadow-[0_0_15px_rgba(234,88,12,0.3)]"
                        >
                            {tech.type === 'devicon' ? (
                                <i className={`${tech.icon} text-3xl text-gray-400 group-hover:text-white transition-colors duration-300 mr-3`}></i>
                            ) : (
                                <MaterialIcon iconName={tech.icon} className="text-3xl text-gray-400 group-hover:text-orange-500 transition-colors duration-300 mr-3"/>
                            )}
                            <p className="text-lg font-semibold text-gray-400 font-body group-hover:text-white transition-colors duration-300 lowercase whitespace-nowrap">
                                {tech.name}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </ScrollFadeIn>
    );
};

const FailuresContent = () => (
    <ScrollFadeIn direction="up">
        <div className="space-y-6">
            {FAILURES.map((failure, index) => (
                <div key={index} className="p-4 bg-gray-900 border border-red-800 rounded-lg shadow-sm font-body interactive-element hover:border-orange-500 transition-colors duration-200 transform hover:scale-[1.01]">
                    <h4 className="font-bold text-red-400 mb-1 font-heading lowercase">{failure.title}</h4>
                    <p className="text-sm text-gray-300 lowercase">{failure.description}</p>
                </div>
            ))}
        </div>
    </ScrollFadeIn>
);

// --- MAIN STRUCTURAL COMPONENTS ---

const HeroSection = () => {
  const [hoverCV, setHoverCV] = useState(false);
  const [hoverHire, setHoverHire] = useState(false);

  return (
    <div className="bg-black text-white py-24 md:py-40 px-4 md:px-8 relative overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between relative z-10">
        <div className="lg:w-2/3 z-20">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-black leading-tight mb-6 animate-slide-in-left font-heading lowercase">
            {PORTFOLIO_DATA.focusAreas.split(' | ').map((word, index) => (
              <span key={index} className={`block ${index === 0 ? 'text-orange-400' : ''}`}>
                {word}
              </span>
            ))}
          </h1>
          <p className="text-md md:text-xl text-gray-400 mb-10 animate-slide-in-left animation-delay-200 font-body lowercase">
            {PORTFOLIO_DATA.locationDetails}
          </p>

          <div className="flex items-center space-x-6 mb-12 text-gray-400">
            {/* Social Icons (using standard SVG for LinkedIn/GitHub as Material Icons often lack these specific logos) */}
            <a href={PORTFOLIO_DATA.linkedin} target="_blank" rel="noopener noreferrer" className="hover:text-orange-500 transition-colors duration-300 interactive-element">
                <i className="fab fa-linkedin text-3xl"></i>
            </a>
            <a href={PORTFOLIO_DATA.medium} target="_blank" rel="noopener noreferrer" className="hover:text-orange-500 transition-colors duration-300 interactive-element">
                <i className="fab fa-medium text-3xl"></i>
            </a>
            <a href={PORTFOLIO_DATA.wakatime} target="_blank" rel="noopener noreferrer" className="hover:text-orange-500 transition-colors duration-300 interactive-element">
              <i className="fas fa-clock text-3xl"></i>
            </a>
          </div>

          <div className="flex flex-wrap gap-4 animate-slide-in-left animation-delay-400">
            {/* Download CV Button */}
            <CallToActionButton
              onMouseEnter={() => setHoverCV(true)}
              onMouseLeave={() => setHoverCV(false)}
              className={`bg-orange-600 text-white shadow-xl hover:shadow-2xl hover:bg-orange-700 transform ${
                hoverCV ? 'scale-105 translate-y-[-2px]' : 'scale-100'
              }`}
              iconName="download_for_offline"
              isSymbol={true}
              onClick={() => window.open('https://storage.googleapis.com/portfolio-items/Rohan-Singh-Resume.pdf', '_blank')}
            >
              download cv
            </CallToActionButton>

            {/* Hire Me Button */}
            <CallToActionButton
              onMouseEnter={() => setHoverHire(true)}
              onMouseLeave={() => setHoverHire(false)}
              className={`bg-white text-orange-600 border-2 border-orange-600 shadow-xl hover:shadow-2xl hover:bg-orange-50 transform ${
                hoverHire ? 'scale-105 translate-y-[-2px]' : 'scale-100'
              }`}
              iconName="waving_hand"
              onClick={() => window.location.href = `mailto:${PORTFOLIO_DATA.email}`}
            >
              hire me
            </CallToActionButton>
          </div>
        </div>

        {/* Floating Image - Positioned absolutely to the right and behind content on large screens */}
        <div className="hidden lg:block absolute top-1/2 right-0 transform -translate-y-1/2 w-[45%] h-full pointer-events-none z-0">
             <div className="relative w-full h-full flex items-center justify-center">
                <img 
                    src={mainPicture} 
                    alt="Rohan Singh" 
                    className="w-full max-w-2xl object-contain opacity-90 mask-image-gradient" 
                />
                 {/* Speech Bubble */}
                <div className="absolute top-1/4 right-10 bg-orange-700 text-white px-6 py-2 rounded-full text-sm font-bold font-body lowercase transform -rotate-6 shadow-xl border-2 border-white z-10 animate-bounce-slow">
                    namaste, i am rohan
                </div>
             </div>
        </div>
      </div>
    </div>
  );
};

const FeaturedMediaItem = ({ title, description, buttonText, mediaComponent, link, alignment = 'left' }) => (
    <ScrollFadeIn direction={alignment === 'right' ? 'right' : 'left'} delay={200}>
        <div className={`flex flex-col lg:flex-row items-center gap-12 py-16 ${alignment === 'right' ? 'lg:flex-row-reverse' : ''}`}>
            <div className="lg:w-1/2">
                <h3 className="text-4xl font-extrabold font-heading text-white mb-6 lowercase">{title}</h3>
                <p className="text-xl text-gray-300 mb-8 leading-relaxed space-mono-regular lowercase">{description}</p>
                <CallToActionButton 
                    iconName="arrow_forward" 
                    className="bg-orange-600 text-white hover:bg-orange-700"
                    onClick={() => link && window.open(link, '_blank')}
                >
                    {buttonText}
                </CallToActionButton>
            </div>
            <div className="lg:w-1/2 w-full">
                {mediaComponent}
            </div>
        </div>
    </ScrollFadeIn>
);

const FeaturedMediaSection = () => (
    <SectionContainer className="bg-gray-900" isDark={true}>
        <FeaturedMediaItem
            title="Google Cloud Success Story"
            description="witness rohan singh's inspiring journey from student to cloud engineer at google cloud partner sada. he cleared the associate cloud engineer certification and now empowers companies worldwide through google cloud. let his story ignite your own cloud ambitions!"
            buttonText="Watch my story"
            link="https://youtu.be/UKKpqs9BTvc?si=RFLGTfSMyNMXxj8v"
            alignment="right"
            mediaComponent={
                <div className="relative pt-[56.25%] bg-black rounded-xl overflow-hidden shadow-xl border-4 border-orange-500 flex items-center justify-center interactive-element hover:border-white transition-colors duration-300 transform hover:scale-[1.01]">
                    <img src={successStoryImg} alt="Google Cloud Success Story - Rohan Singh" className="absolute top-0 left-0 w-full h-full object-cover opacity-80 hover:opacity-100 transition-opacity duration-300" />
                </div>
            }
        />

        <FeaturedMediaItem
            title="the future of infrastructure modernization: how google cloud innovators are embracing the cloud"
            description="rohan singh, a google cloud champion innovator, discusses his expertise in cloud infrastructure modernization and migration. he shares insights on emerging cloud technologies and emphasizes the importance of continuous learning and community engagement in the field."
            buttonText="read the article"
            link="https://cloud.google.com/blog/topics/developers-practitioners/a-conversation-with-google-cloud-champion-innovator-rohan-singh"
            alignment="left"
            mediaComponent={
                <div className="relative pt-[56.25%] bg-black rounded-xl overflow-hidden shadow-xl border-4 border-black interactive-element hover:border-white transition-colors duration-300 transform hover:scale-[1.01]">
                    <img src={cartoonBannerGif} alt="Google Cloud Innovators Animation" className="absolute top-0 left-0 w-full h-full object-cover" />
                </div>
            }
        />

        <FeaturedMediaItem
            title="From Bahraich to Yerevan: An Indian Expat’s Journey into Armenia’s Tech Frontier"
            description="discover rohan's personal journey from india to armenia, exploring the tech ecosystem of armenia and his experiences as an expat making an impact in the global cloud community."
            buttonText="read my journey"
            link="https://www.repatarmenia.org/article/my-experience/from-bahraich-to-yerevan"
            alignment="right"
            mediaComponent={
                <div className="relative pt-[56.25%] bg-black rounded-xl overflow-hidden shadow-xl border-4 border-orange-500 interactive-element hover:border-white transition-colors duration-300 transform hover:scale-[1.01]">
                    <img src={repatArmeniaImg} alt="Rohan Singh Repat Armenia Feature" className="absolute top-0 left-0 w-full h-full object-cover" />
                </div>
            }
        />
    </SectionContainer>
);

const CareerAndCommunitySection = () => (
    <SectionContainer title="professional journey & community" subtitle="my career timeline and community involvement history." isDark={true}>
        <div className="flex flex-col lg:flex-row gap-12">
            <CareerHistoryContent />
            <CommunityExperienceContent />
        </div>
    </SectionContainer>
);

// --- NEW TECHNOLOGY LOGOS SECTION CONTENT ---
const TechnologyLogosSection = () => (
    <SectionContainer isDark={true} className="py-8 md:py-12">
        <div className="max-w-7xl mx-auto">
            <h3 className="text-4xl font-bold font-heading text-gray-500 text-center uppercase tracking-widest mb-8 lowercase">
                core technologies & expertise
            </h3>
            <TechnologyLogosContent />
        </div>
    </SectionContainer>
);

const FailuresSection = () => (
    <SectionContainer title="lessons learned" subtitle="my commitment to growth through transparency and error." isDark={true}>
        <FailuresContent />
    </SectionContainer>
);

const ContentArticlesAndTalks = () => (
    <SectionContainer className="bg-gray-900" isDark={true}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
            
            {/* Blogs/Articles Section */}
            <ScrollFadeIn direction="left">
                <h3 className="text-2xl font-bold font-heading text-white border-b border-gray-700 inline-block pb-1 mb-8 lowercase">
                    technical blogs/articles
                </h3>
                <PaginatedList 
                    items={ARTICLES_AND_TALKS.articles} 
                    itemsPerPage={TECH_ARTICLES_PER_PAGE} 
                    ItemComponent={ArticleItem} 
                    isTalk={false}
                />
            </ScrollFadeIn>
            
            {/* Non-Tech Articles Section */}
            <ScrollFadeIn direction="right" delay={200}>
                <h3 className="text-2xl font-bold font-heading text-white border-b border-gray-700 inline-block pb-1 mb-8 lowercase">
                    non-technical blogs/articles
                </h3>
                <PaginatedList 
                    items={ARTICLES_AND_TALKS.nonTechArticles} 
                    itemsPerPage={NON_TECH_ARTICLES_PER_PAGE} 
                    ItemComponent={ArticleItem} 
                    isTalk={false}
                />
            </ScrollFadeIn>
            
        </div>

        {/* Talks Section - Full Width */}
        <ScrollFadeIn direction="up" delay={300}>
            <h3 className="text-2xl font-bold font-heading text-white border-b border-gray-700 inline-block pb-1 mb-8 lowercase">
                talks
            </h3>
            <PaginatedList 
                items={ARTICLES_AND_TALKS.talks} 
                itemsPerPage={TALKS_PER_PAGE} 
                ItemComponent={ArticleItem} 
                isTalk={true}
            />
        </ScrollFadeIn>
    </SectionContainer>
);

const App = () => {
  useEffect(() => {
    console.log("Portfolio component mounted. Updated with mouse follower and button animations.");
  }, []);

  return (
    <div className="min-h-screen bg-black font-body">
      {/* MOUSE FOLLOWER RENDERED FIRST */}
      <MouseFollower />

      {/* Global Style and Theme Configuration */}
      <style>{`
        /* Import Noto Fonts (Heading and Body) */
        @import url('https://fonts.googleapis.com/css2?family=Noto+Serif+Display:wght@700;900&family=Noto+Sans:wght@400;600;700&display=swap');
        
        /* Import Google Material Icons */
        @import url('https://fonts.googleapis.com/icon?family=Material+Icons+Filled');

        /* Import Space Mono */
        @import url('https://fonts.googleapis.com/css2?family=Space+Mono:ital,wght@0,400;0,700;1,400;1,700&display=swap');

        /* Import Alegreya */
        @import url('https://fonts.googleapis.com/css2?family=Alegreya:ital,wght@0,400..900;1,400..900&display=swap');

        /* Import Sora */
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@100..800&display=swap');

        /* Custom font classes for diversity */
        .font-heading { font-family: 'Alegreya', serif; }
        .font-body { font-family: 'Space Mono', monospace; }
        
        /* Disable default cursor over the entire app */
        body {
          cursor: none !important; 
          font-family: 'Space Mono', monospace;
          overflow-x: hidden;
        }

        /* Specific styles for the mouse follower for blending/smoothness */
        .mouse-follower {
            will-change: width, height, opacity, transform, mix-blend-mode;
        }
        
        /* Entrance Animations (Used in Hero Section for initial load) */
        @keyframes fadeIn { 0% { opacity: 0; } 100% { opacity: 1; } }
        @keyframes slideInLeft { 0% { opacity: 0; transform: translateX(-50px); } 100% { transform: translateX(0); opacity: 1; } }
        @keyframes slideInRight { 0% { opacity: 0; transform: translateX(50px); } 100% { transform: translateX(0); opacity: 1; } }
        
        /* Scroll-Triggered Transitions (Used by ScrollFadeIn component) */
        @keyframes slideUp { 0% { opacity: 0; transform: translateY(20px); } 100% { transform: translateY(0); opacity: 1; } }
        @keyframes slideLeft { 0% { opacity: 0; transform: translateX(-20px); } 100% { transform: translateX(0); opacity: 1; } }
        @keyframes slideRight { 0% { opacity: 0; transform: translateX(20px); } 100% { transform: translateX(0); opacity: 1; } }
        
        .animate-fade-in { animation: fadeIn 0.8s ease-out forwards; }
        .animate-slide-in-left { animation: slideInLeft 0.8s ease-out forwards; }
        .animate-slide-in-right { animation: slideInRight 0.8s ease-out forwards; }

        .animate-slide-up { animation: slideUp 0.8s ease-out forwards; }
        .animate-slide-left { animation: slideLeft 0.8s ease-out forwards; }
        .animate-slide-right { animation: slideRight 0.8s ease-out forwards; }
        .animate-fade-in-slow { animation: fadeIn 1.2s ease-out forwards; }

        /* Set default font family for the whole app */
        body {
          font-family: 'Noto Sans', sans-serif;
          overflow-x: hidden;
        }
        
        /* Utility for animation delay */
        .animation-delay-200 { animation-delay: 0.2s; }
        .animation-delay-400 { animation-delay: 0.4s; }

        /* --- TECHNOLOGY LOGO SCROLL ANIMATION --- */
        @keyframes slide-rtl {
            /* 50% ensures the animation perfectly loops when two copies of the content are used */
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); } 
        }

        .scrolling-container {
            /* Calculate the time based on the number of logos * desired speed (e.g., 2 seconds per logo) */
            animation: slide-rtl 30s linear infinite; 
            width: 200%; /* Must be double the content width for the loop */
        }
      `}</style>


      <HeroSection />
      <FeaturedMediaSection />
      
      {/* PROFESSIONAL CORE: Career History (Left) and Community Experience (Right) */}
      <CareerAndCommunitySection /> 
      
      {/* NEW SECTION: Technology Logos (Now animated) */}
      <TechnologyLogosSection />
      
      <ContentArticlesAndTalks />

      <WinsAndLessonsSection />

      <footer className="text-center py-12 bg-black text-white border-t border-gray-800 font-body">
        <h4 className="text-2xl font-bold mb-2 font-heading lowercase">let's build something scalable.</h4>
        <p className="text-gray-400 mb-6 lowercase">reach out to discuss cloud strategy, devops, f1 or motorcycles.</p>
        <a 
            href={`mailto:${PORTFOLIO_DATA.email}`} 
            className="flex items-center justify-center mx-auto w-fit px-8 py-3 rounded-lg bg-orange-600 text-white hover:bg-orange-700 transition duration-200 shadow-lg shadow-orange-500/50 interactive-element sora-regular"
        >
            <MaterialIcon iconName="send" className="text-xl mr-2" />
            connect via email
        </a>
        <p className="text-xs text-gray-500 mt-8 lowercase">build with gemini 3 and antigravity in 9 hrs and 24 mins</p>
      </footer>
    </div>
  );
};

export default App;